<template>
  <div class="complaint">
    <div class="complaintTitleWrapper">
      <h1 class="complaintTitle">ثبت شکایت به اتحادیه املاک بابل</h1>
      <p class="complaintSubtitle">
        درصورت مشاهده تخلف یا رفتار ناصحیح، می‌توانید از مشاور یا همکار خود
        شکایت ثبت کنید. اتحادیه پس از بررسی نتیجه را به شما اطلاع خواهد داد.
      </p>
    </div>
    <div class="complaintContainer">
      <form class="containerForm" @submit.prevent="submitComplaintHandler">
        <div class="formGroup thirdGroup">
          <label for="accused" class="groupLabel">طرف شکایت</label>
          <el-select v-model="form.target" id="accused" placeholder="">
            <el-option label="مشاور املاک" value="amlak" />
            <el-option label="مباشر" value="consultant" />
          </el-select>
        </div>
        <div class="formGroup thirdGroup">
          <label for="accusedName" class="groupLabel"
            >نام شخص / دفتر املاک</label
          >
          <input
            type="text"
            v-model="form.nickname"
            id="accusedName"
            class="groupInput"
          />
        </div>
        <div class="formGroup thirdGroup">
          <label for="topic" class="groupLabel">موضوع شکایت</label>
          <el-select v-model="form.subject" id="topic" placeholder="">
            <el-option
              v-for="(key, value) in subjectList"
              :key="value"
              :label="key"
              :value="value"
            />
          </el-select>
        </div>
        <div class="formGroup">
          <label for="desc" class="groupLabel descLabel"
            >توضیحات
            <span class="showInfo" @click="descTooltipHandler">
              <VsxIcon
                iconName="InfoCircle"
                :size="22"
                color="#0096c7"
                type="linear"
              />
            </span>
          </label>
          <textarea
            v-model="form.des"
            id="desc"
            minlength="40"
            maxlength="600"
            rows="5"
            class="groupTextarea"
            :placeholder="descPlaceholder"
          ></textarea>
        </div>
        <div class="formGroup halfGroup">
          <label for="complainant_name" class="groupLabel">نام شاکی</label>
          <div class="disabledFormWrapper">
            <div
              class="disabledThumb"
              @click.stop="changeDenyValidation('name')"
            ></div>
            <input
              type="text"
              :value="form.beefer"
              id="complainant_name"
              class="groupInput disabled"
              disabled
            />
          </div>
        </div>
        <div class="formGroup halfGroup">
          <label for="complainant_phone" class="groupLabel">شماره تماس</label>
          <div class="disabledFormWrapper">
            <div
              class="disabledThumb"
              @click.stop="changeDenyValidation('phone')"
            ></div>
            <input
              type="text"
              :value="form.phone"
              id="complainant_phone"
              class="groupInput disabled"
              inputmode="numeric"
              disabled
            />
          </div>
        </div>
        <div class="formGroup docGroup">
          <div class="docUpload">
            <input
              ref="fileInput"
              type="file"
              class="uploadInput"
              multiple
              @change="handleFileUpload"
              accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.doc,.docx,.xls,.xlsx,.mp4,.mp3,.wav"
            />
            <div class="docUploadBtn" @click="$refs.fileInput.click()">
              افزودن مدارک
            </div>
          </div>
          <div class="filePreviewWrapper">
            <div
              class="filePreviewItem"
              v-for="(fileObj, index) in uploadedFiles"
              :key="index"
            >
              <img :src="getFileIcon(fileObj)" class="fileIconImg" alt="icon" />
              <span class="fileName">{{ fileObj.name }}</span>
              <button class="removeBtn" @click="removeFile(index)">❌</button>
            </div>
          </div>
        </div>
        <div class="formGroup">
          <div class="groupCheckBoxWrapper">
            <div class="checkBoxInput">
              <div class="customCheckBox" :class="{ checked: form.is_hide }">
                <input type="checkbox" v-model="form.is_hide" id="anonymous" />
                <div class="checkTick">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path
                      d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <label for="anonymous" class="checkBoxTitle"
              >می‌خواهم شکایت من، ناشناس بماند.</label
            >
          </div>
          <div class="groupCheckBoxWrapper">
            <div class="checkBoxInput">
              <div
                class="customCheckBox"
                :class="{ checked: form.confirmation }"
              >
                <input
                  type="checkbox"
                  v-model="form.confirmation"
                  id="confirmation"
                />
                <div class="checkTick">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path
                      d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <label for="confirmation" class="checkBoxTitle">
              صحت اطلاعات فوق را تایید می‌کنم و می‌دانم مسئولیت حقوقی آن برعهده
              اینجانب می‌باشد.
            </label>
          </div>
        </div>
        <button
          v-if="!loading"
          class="formSubmitBtn"
          :class="{ disaled: !form.confirmation }"
          type="submit"
        >
          ثبت شکایت
        </button>
        <div v-else class="formSubmitBtn">
          <div class="complaintLoader"></div>
        </div>
      </form>
      <el-dialog
        v-model="showResult"
        align-center
        class="complaintResult"
        @close="showResult = false"
      >
        <div class="dialogCloseBtn" @click="showResult = false">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="size-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18 18 6M6 6l12 12"
            />
          </svg>
        </div>
        <div class="resultSeccuss">
          <div class="successedIcon">
            <i class="fas fa-check"></i>
          </div>
        </div>
        <h2 class="resultTitle">شکایت شما با موفقیت ثبت شد</h2>
        <p class="rsultSubtitle">
          کدپیگیری شکایت شما {{ trackingNumber }} می‌باشد.
        </p>
        <div class="resultBtns">
          <div @click="changeRouteHAndler" class="resultBtn">پیگیری شکایت</div>
          <div @click="routeBackHAndler" class="resultBtn BackBtn">بازگشت</div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { toast } from "vue3-toastify";
import Compressor from "compressorjs";
import axios from "axios";
export default {
  name: "ComplaintPage",
  data() {
    return {
      showResult: false,
      form: {
        confirmation: false,
        uid: this.$store.state.auth.uid,
        subject: "",
        target: "",
        nickname: "",
        des: "",
        beefer: this.$store.state.auth.nickname,
        phone: this.$store.state.auth.mobile,
        is_hide: "",
        files: [],
      },
      loading: false,
      subjectList: [],
      uploadedFiles: [],
      trackingNumber: "",
      descPlaceholder: "",
    };
  },
  methods: {
    handleFileUpload(event) {
      const files = Array.from(event.target.files);
      const remainingSlots = 3 - this.form.files.length;

      if (remainingSlots <= 0) {
        toast("حداکثر 3 فایل مجاز است", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        event.target.value = "";
        return;
      }

      const selectedFiles = files.slice(0, remainingSlots);

      selectedFiles.forEach((file) => {
        if (file.type.startsWith("image/")) {
          new Compressor(file, {
            quality: 0.6,
            maxWidth: 1920,
            success: (compressedBlob) => {
              const compressedFile = new File([compressedBlob], file.name, {
                type: compressedBlob.type,
              });

              this.form.files.push(compressedFile);
              this.uploadedFiles.push({
                file: compressedFile,
                name: file.name,
                type: file.type,
              });
            },
            error(err) {
              console.error("خطا در فشرده‌سازی:", err.message);
            },
          });
        } else {
          const maxSizeInBytes = 5 * 1024 * 1024;

          if (file.size > maxSizeInBytes) {
            toast("حجم فایل شما بیشتر از 5 مگابایت است ", {
              type: "error",
              dangerouslyHTMLString: true,
            });
            return;
          }

          const wrappedFile = new File([file], file.name, {
            type: file.type,
            lastModified: file.lastModified,
          });

          this.form.files.push(wrappedFile);
          this.uploadedFiles.push({
            file: wrappedFile,
            name: file.name,
            type: file.type,
          });
        }
      });

      event.target.value = "";
    },
    getFileIcon(fileObj) {
      const name = fileObj.name.toLowerCase();
      const type = fileObj.type;

      if (type.startsWith("image/"))
        return require("@/assets/icons/image-icon.png");
      if (type === "application/pdf")
        return require("@/assets/icons/pdf-icon.png");
      if (name.endsWith(".doc") || name.endsWith(".docx"))
        return require("@/assets/icons/word-icon.png");
      if (name.endsWith(".xls") || name.endsWith(".xlsx"))
        return require("@/assets/icons/excel-icon.png");
      if (type.startsWith("video/"))
        return require("@/assets/icons/video-icon.png");
      if (type.startsWith("audio/"))
        return require("@/assets/icons/audio-icon.png");
      return require("@/assets/icons/file-icon.png");
    },
    removeFile(index) {
      this.form.files.splice(index, 1);
      this.uploadedFiles.splice(index, 1);
    },
    routeBackHAndler() {
      history.back();
      this.showResult = false;
    },
    changeRouteHAndler() {
      this.$router.push("/complaint-tracking");
      this.showResult = false;
    },
    getComplaintSubjectHandler() {
      this.helperPost("subject-list", {
        uid: this.$store.state.auth.uid,
      }).then((response) => {
        if (response.data.result == 1) {
          this.subjectList = response.data.data;
        }
      });
    },
    submitComplaintHandler() {
      if (!this.inputValidation()) {
        return;
      }
      let self = this;
      this.loading = true;
      const formData = new FormData();

      formData.append("uid", this.form.uid);
      formData.append("target", this.form.target);
      formData.append("nickname", this.form.nickname);
      formData.append("subject", this.form.subject);
      formData.append("des", this.form.des);
      formData.append("beefer", this.form.beefer);
      formData.append("phone", this.form.phone);
      formData.append("is_hide", this.form.is_hide ? "1" : "0");
      formData.append("confirmation", this.form.confirmation ? "1" : "0");
      formData.append("token", this.form.token || "");

      this.form.files.forEach((file) => {
        formData.append("files[]", file);
      });

      axios
        .post(self.$store.getters.baseUrl + "/save-complaint", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + self.$store.getters.appToken,
          },
        })
        .then((response) => {
          if (response.data.result == "success") {
            this.showResult = true;
            this.trackingNumber = response.data.tracking_number;
            this.form = {
              confirmation: false,
              uid: this.$store.state.auth.uid,
              subject: "",
              target: "",
              nickname: "",
              des: "",
              beefer: this.$store.state.auth.nickname,
              phone: this.$store.state.auth.mobile,
              is_hide: "",
              files: [],
            };
          } else {
            toast(response.data.msg, {
              type: "error",
              dangerouslyHTMLString: true,
            });
          }
          this.loading = false;
        });
    },
    changeDenyValidation(type) {
      if (type == "name") {
        toast("فیلد نام شاکی قابل تغییر نمی‌باشد", {
          type: "error",
          dangerouslyHTMLString: true,
        });
      } else {
        toast("فیلد شماره تماس قابل تغییر نمی‌باشد", {
          type: "error",
          dangerouslyHTMLString: true,
        });
      }
    },
    inputValidation() {
      if (this.form.target == "") {
        toast("طرف شکایت خود را انتخاب کنید", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return false;
      } else if (this.form.nickname == "") {
        toast("نام طرف شکایت خود را وارد کنید", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return false;
      } else if (this.form.subject == "") {
        toast("موضوع شکایت خود را انتخاب کنید", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return false;
      } else if (!this.form.confirmation) {
        toast("برای ادامه، لطفاً صحت اطلاعات را تأیید کنید. ", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return false;
      } else {
        return true;
      }
    },
    descTooltipHandler() {
      if (this.descPlaceholder == "") {
        this.descPlaceholder =
          "لطفاً شکایت خود را به‌طور واضح و بدون به‌کار بردن عبارات توهین‌آمیز، همراه با ذکر زمان، مکان و نوع برخورد ارائه دهید.";
      } else {
        this.descPlaceholder = "";
      }
    },
  },
  mounted() {
    this.getComplaintSubjectHandler();
  },
};
</script>

<style scoped lang="scss">
.complaint {
  width: 66%;
  margin: 0 auto;
  padding-bottom: 32px;
  padding-top: 82px;
  .complaintTitleWrapper {
    width: 100%;
    text-align: center;
    margin: 18px 0;
    .complaintTitle {
      position: relative;
      font-family: "iranyekanB", sans-serif;
      font-size: 1.35rem;
      margin: 16px auto 12px;
      text-align: center;
      color: #0096c7;
    }

    .complaintSubtitle {
      width: 100%;
      font-size: 0.9rem;
      line-height: 24px;
      max-width: 600px;
      margin-left: auto;
      margin-right: auto;
      text-align: center;
    }
  }

  .complaintContainer {
    padding-top: 16px;
    .containerForm {
      width: 98%;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .formSubmitBtn {
        width: 100%;
        height: 47px;
        background: linear-gradient(to right, #0096c7, #00b4d8);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.95rem;
        border-radius: 12px;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
        cursor: pointer;
        max-width: 468px;
        &.disaled {
          background: #b2b2b2;
        }
      }

      .formGroup {
        width: 100%;
        margin-bottom: 18px;
        &.thirdGroup {
          width: 31.5%;
        }
        &.halfGroup {
          width: 48.5%;
        }
        .groupLabel {
          display: block;
          font-size: 0.85rem;
          margin-bottom: 8px;
          margin-right: 6px;
          opacity: 0.85;

          &.descLabel {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .showInfo {
              display: block;
              cursor: pointer;
            }
          }
        }

        :deep(.el-select .el-select__wrapper) {
          width: 100%;
          height: 47px;
          border-radius: 5px !important;
          background: #fff !important;
          border: 1px solid rgb(209, 213, 219);
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
          padding: 12px !important;
          border-radius: 12px !important;
        }

        :deep(.el-select__caret) {
          color: #0096c7 !important;
        }

        .disabledFormWrapper {
          position: relative;

          .disabledThumb {
            position: absolute;
            inset: 0;
            z-index: 1;
          }
        }

        .groupInput {
          width: 100%;
          height: 47px;
          background: #fff !important;
          border: 1px solid rgb(209, 213, 219);
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
          padding: 12px !important;
          border-radius: 12px !important;
          font-size: 0.95rem;

          &.disabled {
            position: relative;
            background: #f2f2f2 !important;
            z-index: 0;
          }
        }

        .groupTextarea {
          width: 100%;
          background: #fff !important;
          border: 1px solid rgb(209, 213, 219);
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
          padding: 12px !important;
          border-radius: 12px !important;
          resize: none;
          font-size: 0.9rem;
          line-height: 24px;
        }

        .gropuSelectWrapper {
          position: relative;

          .inputIcon {
            position: absolute;
            top: 50%;
            right: 14px;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
            color: #0096c7;
            z-index: 1;

            &.awesomeIcon {
              svg {
                width: 16px;
                height: 16px;
                fill: #0096c7;
              }
            }

            &::after {
              content: "";
              display: block;
              width: 32px;
              height: 32px;
              background: rgba(0, 150, 199, 0.1);
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              border-radius: 50%;
              z-index: 0;
            }

            svg {
              position: relative;
              z-index: 1;
              width: 20px;
              height: 20px;
            }
          }
        }

        .groupCheckBoxWrapper {
          display: flex;
          align-items: center;
          gap: 12px;
          &:first-of-type {
            margin-bottom: 8px;
          }

          .checkBoxInput {
            width: 20px;
            height: 20px;
            flex-shrink: 0;

            .customCheckBox {
              position: relative;
              width: 100%;
              height: 100%;
              border-radius: 0.375rem;
              border: 2px solid rgb(209, 213, 219);
              box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
              overflow: hidden;

              &.checked {
                border-color: #0096c7;
                .checkTick {
                  display: flex;
                }
              }

              input {
                position: absolute;
                inset: 0;
                width: 100%;
                height: 100%;
                opacity: 0;
                z-index: 1;
              }

              .checkTick {
                display: none;
                position: relative;
                width: 100%;
                height: 100%;
                z-index: 0;
                background: #0096c7;
                align-items: center;
                justify-content: center;

                svg {
                  width: 14px;
                  height: 14px;
                  fill: #fff;
                }
              }
            }
          }

          .checkBoxTitle {
            font-size: 0.775rem;
            opacity: 0.75;
            line-height: 16px;
          }
        }

        &.docGroup {
          display: flex;
          align-items: center;
          gap: 24px;
        }

        .docUpload {
          position: relative;
          width: 24%;
          height: 47px;
          margin-top: 12px;
          margin-bottom: 12px;
          overflow: hidden;

          .uploadInput {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
            opacity: 0;
            cursor: pointer;
          }

          .docUploadBtn {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            z-index: 0;
            background: linear-gradient(to right, #0096c7, #00b4d8);
            font-size: 0.95rem;
            border-radius: 12px;
            box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
            color: #fff;
          }
        }

        .filePreviewWrapper {
          width: 100%;
          display: flex;
          align-items: flex-start;
          flex-wrap: wrap;
          gap: 16px;

          .filePreviewItem {
            display: block;
            padding: 8px 24px;
            display: flex;
            align-items: center;
            gap: 6px;
            border: 1px solid #cecece;
            border-radius: 12px;
            height: 44px;

            .fileIconImg {
              width: 20px;
            }

            .fileName {
              display: block;
              font-size: 0.9rem;
              margin-top: 4px;
              margin-right: 4px;
              max-width: 84px;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }

        .groupInputWrapper {
          width: 100%;
          height: 47px;
          display: grid;
          grid-template-columns: 47px 1fr;
          align-items: center;
          background: #fff !important;
          border: 1px solid rgb(209, 213, 219);
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
          border-radius: 12px !important;
          overflow: hidden;

          .inputIcon {
            position: relative;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #0096c7;

            &.awesomeIcon {
              svg {
                width: 16px;
                height: 16px;
                fill: #0096c7;
              }
            }

            &::after {
              content: "";
              display: block;
              width: 32px;
              height: 32px;
              background: rgba(0, 150, 199, 0.1);
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              border-radius: 50%;
              z-index: 0;
            }

            svg {
              position: relative;
              z-index: 1;
              width: 24px;
              height: 24px;

              &.mortageIcon,
              &.rentIcon {
                width: 20px;
                height: 20px;
              }
            }
          }

          .inputUnit {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #0096c7;
            font-size: 0.8rem;
          }

          .groupInput {
            width: 100%;
            height: 100%;
            border: none;
            box-shadow: none;
            border-radius: 0;
            text-align: center;
            font-size: 1rem;
          }
        }
      }
    }

    .complaintResult {
      padding: 92px 0;
      .resultSeccuss {
        display: flex;
        justify-content: center;
        margin-bottom: 24px;

        .successedIcon {
          background: #d3ffd4;
          width: 64px;
          height: 64px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;

          i {
            color: #00e004;
            font-size: 1.5rem;
            line-height: 2rem;
          }
        }
      }

      .resultTitle {
        font-family: "iranyekanB", sans-serif;
        font-size: 1.15rem;
        text-align: center;
        margin-bottom: 8px;
      }

      .rsultSubtitle {
        text-align: center;
        font-size: 0.95rem;
        margin-bottom: 24px;
      }

      .resultBtns {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;

        .resultBtn {
          height: 40px;
          padding: 0 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 6px;
          font-size: 0.95rem;
          color: #fff;
          cursor: pointer;

          &:not(.BackBtn) {
            background: #0096c7;
          }

          &.BackBtn {
            background: #f00;
          }
        }
      }
    }
  }
}

@media (max-width: 1000px) {
  .complaint {
    width: 90%;
    padding-top: 0;

    .complaintContainer {
      .containerForm {
        .formGroup {
          &.thirdGroup,
          &.halfGroup {
            width: 100%;
          }

          &.docGroup {
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;
          }

          .docUpload {
            width: 38%;
            margin-left: 0;
            margin-right: 0;
          }
        }
      }
    }
  }
}

.dark {
  .complaint {
    color: #fff;

    .complaintContainer {
      .containerForm {
        .formGroup {
          :deep(.el-select .el-select__wrapper) {
            box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.1);
            border: 1px solid #2a3b47;
            background: #101a23 !important;
          }
          :deep(
              .el-select
                .el-select__wrapper
                .el-select__selection
                .el-select__placeholder
                span
            ) {
            color: #fff !important;
          }

          .groupInput {
            background: #101a23 !important;
            box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.1);
            border: 1px solid #2a3b47;
            color: #fff;

            &.disabled {
              background: #1e262e !important;
            }
          }

          .groupTextarea {
            background: #101a23 !important;
            box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.1);
            border: 1px solid #2a3b47;
            color: #fff;
          }
          .groupCheckBoxWrapper {
            .checkBoxInput {
              .customCheckBox {
                background: #101a23 !important;
                box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.1);
                border: 2px solid #2a3b47;

                &.checked {
                  border-color: #0096c7;
                }
              }
            }
          }
        }
      }
    }
  }
}

:deep(.el-overlay-dialog) {
  .complaintResult {
    position: relative;
    max-width: 432px;
    width: 90%;
    padding: 54px 24px;
    border-radius: 12px !important;
    .dialogCloseBtn {
      position: absolute;
      top: 16px;
      right: 16px;
      color: #0096c7;
      cursor: pointer;

      svg {
        width: 32px;
        height: 32px;
        stroke-width: 1;
      }
    }
    .el-dialog__header {
      display: none;
    }
  }
}

.complaintLoader {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-block;
  border-top: 3px solid #fff;
  border-right: 3px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
